import { call, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'
export function createNavigateTo(path) {
  return function*() {
    yield call(navigateTo, path);
  };
}

export function* navigateTo(path) {
  yield put(push(path))
}
